import { get } from '@/services/FetchServices';

import { IOnboardingConfig } from '@/store/types/integration-config.types';

import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';

export class IntegrationConfigService {
  static queryKey = 'IntegrationConfig';
  static getOnboardingUrl = async (): Promise<IOnboardingConfig> => {
    try {
      const config = getStaticDashboardConfig();

      return await get(
        {
          url: `${config.api.baseUrl}/core-connect/onboarding/config`,
          action: this.queryKey,
        },
        { shouldSkipEncryption: true, isSingle: true },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };

  static updateOnboardingUrl = async (urlUpdated: IOnboardingConfig): Promise<IOnboardingConfig> => {
    try {
      const config = getStaticDashboardConfig();

      return await get(
        {
          url: `${config.api.baseUrl}/core-connect/onboarding/config`,
          method: 'PUT',
          body: urlUpdated,
          action: this.queryKey,
        },
        { shouldSkipEncryption: true, isSingle: true },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
